/**
 * Request-size guard rails, not product rules. Here rather than beside the DTO
 * so the create form bounds the same numbers the tRPC input and the data-layer
 * schema do — otherwise an over-size selection fails as a raw input error with
 * no field to attach it to.
 */
export const MAX_SCHEDULER_TARGETS = 200;
export const MAX_SCHEDULER_ASSIGNEES = 50;
